function loadView(view) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `@/components/${view}.vue`)
}
import TournamentRoutes from './front/tournaments'
import DivisionRoutes from './front/divisions'
import TeamRoutes from './front/teams'
import UserRoutes from './front/users'
import ShopRoutes from './Shop'

const routesGeneral = [
	// Home
	{
		path: 'home',
		name: 'FrontHome',
		component: loadView('Front/Home')
	},
	// Torneos
	{
		path: 'tournament/:tournamentSlug',
		component: loadView('Front/Tournament/Main'),
		children: TournamentRoutes
	},
	// Divisiones
	{
		path: 'division/:divisionSlug',
		component: loadView('Front/Division/Main'),
		children: DivisionRoutes
	},
	// Equipos
	{
		path: 'team/:teamSlug',
		component: loadView('Front/Team/Main'),
		children: TeamRoutes
	},
	// Jugadores
	{
		path: 'player/:playerSlug',
		component: loadView('Front/Player/Main'),
		children: UserRoutes
	},
	// Users
	{
		path: 'player/:playerSLug/notices/:noticeSlug',
		name: 'FrontUserNotice',
		component: loadView('Front/User/Notices/Details')
	},
	{
		path: 'donations',
		name: 'Donations',
		component: loadView('Front/Donations')
	}
]

ShopRoutes.map(route => {
	routesGeneral.push(route)
})
const routes = [
	{
		path: '',
		name: 'Home',
		component: loadView('Home')
	},
	{
		path: 'login',
		name: 'Login',
		component: loadView('Auth/Login')
	},
	{
		path: 'recuperar-contrasena',
		name: 'RecoverPassword',
		component: loadView('Auth/SendLink')
	},
	{
		path: 'cambiar-contrasena/token/:token',
		name: 'ResetPassword',
		component: loadView('Auth/ResetPassword')
	},
	{
		path: 'registro',
		name: 'Register',
		component: loadView('Auth/Register')
	},
	{
		path: 'sobre-nosotros',
		name: 'AboutUs',
		component: loadView('AboutUs')
	},
	{
		path: 'console/:console',
		component: loadView('Front'),
		children: routesGeneral
	},
	{
		path: 'console/:console/notices/:slug',
		name: 'Notice',
		component: loadView('Front/Notice')
	}
]

export default routes
